import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";


const BillExternalContractManager = () => {

  const clearPagi = useRef();
  const [deliveryProviderColObj, setDeliveryProviderColObj] = useState();
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);

  const [filter, setFilter] = useState({
    monthYear: searchParams.get("monthYear") || moment().format('YYYY-MM'),
  });

  useEffect(() => {
    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });
    getData();
  }, [timeNow, filter]);

  const getData = () => {
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        monthYear: filter.monthYear,
      };

      GET(`bill-external-contract/find-all-by-month`, params, true)
        .then(({ data: { rows, deliveryProviderColObj, summary } }) => {
          setData([...rows]);
          setSummary(summary)
          setDeliveryProviderColObj(deliveryProviderColObj);

        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  };

  const exportExcel = () => {
    const params = new URLSearchParams({
      monthYear: filter.monthYear,
      token: getToken(),
    });
    const url = `${process.env.REACT_APP_API_URL
      }/api/v1/bill-external-contract/find-all-by-month-excel?${params.toString()}`;
    window.open(url, "_blank");
  };

  const numColDeliveryProvider = useMemo(() => {
    const result = {
      total: 0,
      colByProvider: {}
    }
    if (!deliveryProviderColObj) {
      return result
    };
    Object.values(deliveryProviderColObj).forEach((deliverProvider) => {
      const col = Object.keys(deliverProvider.warehouse).length + 1;
      result.colByProvider[deliverProvider.id] = col
      result.total += col
    })
    return result
  }, [data, deliveryProviderColObj])
  return (
    <React.Fragment>
      <Head title="Quản lý hợp đồng xuất khẩu"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Hợp đồng xuất khẩu tháng {moment(filter.monthYear, 'YYYY-MM').format('MM-YYYY')}</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          color="primary"
                          onClick={() => {
                            history.push("/bill-external-contract/create");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button color="secondary" onClick={exportExcel}>
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <table className="table-bordered w-100 table table-responsive">
                    <tbody>
                      <tr>
                        <td rowSpan={3}>Tên HĐ</td>
                        <td rowSpan={3}>Khách hàng</td>
                        <td rowSpan={3}>Tàu chạy</td>
                        <td rowSpan={3}>SL HĐ</td>
                        <td rowSpan={3}>SL tháng</td>
                        <td rowSpan={3}>Đơn giá($)</td>
                        <td rowSpan={3}>Thành tiền ($)</td>
                        <td rowSpan={3}>Cont tháng</td>

                        <td
                          rowSpan={1}
                          colSpan={numColDeliveryProvider.total}
                        >
                          ĐƠN VỊ VẬN TẢI VÀ KHO XUẤT
                        </td>

                        <td rowSpan={2} colSpan={4}>
                          Phí cảng bãi
                        </td>
                      </tr>

                      <tr>
                        {Object.values(deliveryProviderColObj || {}).map(provider => {
                          return <td key={provider.id} colSpan={numColDeliveryProvider.colByProvider[provider.id]}>{provider.name}</td>
                        }
                        )}
                      </tr>
                      <tr>
                        <>
                          {Object.values(deliveryProviderColObj || {}).map(provider =>
                            <>
                              {
                                Object.values(provider.warehouse).map(warehouse =>
                                  <td key={warehouse.id}>{warehouse.name}</td>
                                )
                              }
                              <td>Thành tiền</td>
                            </>
                          )}

                          <td>Phí nâng</td>
                          <td>Phí hạ</td>
                          <td>Bồi dưỡng</td>
                          <td>CSHT</td>
                        </>
                      </tr>
                      <tr>
                        <td colSpan={4}>Tổng cộng ({summary?.countOfContract} hợp đồng)</td>
                        <td><NumericFormat
                          value={summary?.quantity || 0}
                          displayType={'text'}
                          decimalScale={2}
                          thousandSeparator={','}
                          thousandsGroupStyle="thousand"
                        /></td>
                        <td><NumericFormat
                          value={summary?.contractUnitPrice || 0}
                          displayType={'text'}
                          decimalScale={2}
                          thousandSeparator={','}
                          thousandsGroupStyle="thousand"
                        /></td>
                        <td><NumericFormat
                          value={summary?.contractSubtotal || 0}
                          displayType={'text'}
                          decimalScale={2}
                          thousandSeparator={','}
                          thousandsGroupStyle="thousand"
                        /></td>
                        <td><NumericFormat
                          value={summary?.numOfContainer || 0}
                          displayType={'text'}
                          decimalScale={2}
                          thousandSeparator={','}
                          thousandsGroupStyle="thousand"
                        /></td>
                        {Object.values(deliveryProviderColObj || {}).map(provider =>
                          <>
                            {
                              Object.values(provider.warehouse || {}).map(warehouse =>
                                <td>
                                  <NumericFormat
                                    value={summary?.deliveryProvider?.[provider.id]?.[warehouse.id]?.numOfContainer || 0}
                                    displayType={'text'}
                                    decimalScale={2}
                                    thousandSeparator={','}
                                    thousandsGroupStyle="thousand"
                                  />
                                </td>
                              )
                            }
                            <td>
                              <NumericFormat
                                value={summary?.deliveryProvider?.[provider.id]?.deliveryFeeExternal || 0}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                          </>
                        )}
                        <td>
                          <NumericFormat
                            value={summary?.liftOnFee || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />
                        </td>
                        <td>
                          <NumericFormat
                            value={summary?.liftOffFee || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />
                        </td>
                        <td>
                          <NumericFormat
                            value={summary?.inDriverFosteringUpDownContainerFee || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />
                        </td>
                        <td>
                          <NumericFormat
                            value={summary?.infrastructureFee || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />
                        </td>
                      </tr>
                      {(data &&
                        data.length &&
                        data.map((c) => (
                          <tr>
                            <td>{c.name}</td>
                            <td>{c?.customer?.name}</td>
                            <td>
                              {c.shipStartDate &&
                                moment(c.shipStartDate).format("DD/MM/YYYY")}
                            </td>

                            <td><NumericFormat
                              value={c.contractQuantity || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            <td><NumericFormat
                              value={c.quantity || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            <td><NumericFormat
                              value={c.contractUnitPrice || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            <td><NumericFormat
                              value={c.contractSubtotal || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            <td><NumericFormat
                              value={c.numOfContainer || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            /></td>
                            {Object.values(deliveryProviderColObj || {}).map(provider =>
                              <>
                                {
                                  Object.values(provider.warehouse || {}).map(warehouse =>
                                    <td>
                                      <NumericFormat
                                        value={c.deliveryProvider?.[provider.id]?.[warehouse.id]?.numOfContainer || 0}
                                        displayType={'text'}
                                        decimalScale={2}
                                        thousandSeparator={','}
                                        thousandsGroupStyle="thousand"
                                      />
                                    </td>
                                  )
                                }
                                <td>
                                  <NumericFormat
                                    value={
                                      Object.values(provider.warehouse || {}).reduce((prev, warehouse) => prev + (c.deliveryProvider?.[provider.id]?.[warehouse.id]?.deliveryFeeExternal || 0), 0)
                                    }
                                    displayType={'text'}
                                    decimalScale={2}
                                    thousandSeparator={','}
                                    thousandsGroupStyle="thousand"
                                  />
                                </td>
                              </>
                            )}
                            <td>
                              <NumericFormat
                                value={c?.liftOnFee || 0}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c?.liftOffFee || 0}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c?.inDriverFosteringUpDownContainerFee || 0}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                            <td>
                              <NumericFormat
                                value={c?.infrastructureFee || 0}
                                displayType={'text'}
                                decimalScale={2}
                                thousandSeparator={','}
                                thousandsGroupStyle="thousand"
                              />
                            </td>
                          </tr>
                        ))) || (
                          <tr>
                            <td colSpan={999}>Không có dữ liệu</td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default BillExternalContractManager;
